import { useQuery } from "react-query";
import { useMsal, useAccount } from "@azure/msal-react";
import { useTokenQuery } from "./useTokenQuery";
import { fetchWithAuth } from "../components/helpers/fetchWithAuth";

export function useUserContextQuery() {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const tokenQuery = useTokenQuery();

  return useQuery(
    "user-context",
    async () => {
      let apiUrl = process.env.REACT_APP_API_URI.trim();
      return fetchWithAuth(
        `${apiUrl}/operator/user-context`,
        { method: "get" },
        instance,
        account,
        inProgress,
      );
    },
    {
      enabled: !!accounts.length && inProgress === "none" && !!tokenQuery.data,
      staleTime: 10 * 60 * 1000,
    },
  );
}
